import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { Toaster } from '@/components/ui/sonner';
import ProtectedRoute from '@/components/ProtectedRoute';

// Visitor form is the first screen for public visitors — keep it eager.
import VisitorHome from '@/pages/visitor/VisitorHome';

// Admin & Super Admin code is lazy-loaded so it never ships in the visitor's
// initial bundle. Each becomes its own chunk, loaded only when navigated to.
const CustomerAdminLogin = lazy(() => import('@/pages/customer/Login'));
const CustomerDashboard = lazy(() => import('@/pages/customer/Dashboard'));
const ForgotPassword = lazy(() => import('@/pages/customer/ForgotPassword'));
const ResetPassword = lazy(() => import('@/pages/customer/ResetPassword'));
const AccountSetup = lazy(() => import('@/pages/customer/AccountSetup'));
const SuperAdminLogin = lazy(() => import('@/pages/superadmin/Login'));
const SuperAdminDashboard = lazy(() => import('@/pages/superadmin/Dashboard'));

import './App.css';

function AppRouter() {
  return (
    <Routes>
      {/* Super Admin */}
      <Route path="/superadmin/login" element={<SuperAdminLogin />} />
      <Route
        path="/superadmin/*"
        element={
          <ProtectedRoute requiredRole="superadmin">
            <SuperAdminDashboard />
          </ProtectedRoute>
        }
      />

      {/* Customer Admin */}
      <Route path="/admin/login" element={<CustomerAdminLogin />} />
      <Route path="/admin/forgot-password" element={<ForgotPassword />} />
      <Route path="/admin/reset-password" element={<ResetPassword />} />
      <Route path="/admin/setup" element={<AccountSetup />} />
      <Route
        path="/admin/*"
        element={
          <ProtectedRoute requiredRole="customer_admin">
            <CustomerDashboard />
          </ProtectedRoute>
        }
      />

      {/* Visitor Interface - Dynamic path routing */}
      <Route path="/:subdomain" element={<VisitorHome />} />

      {/* Root */}
      <Route path="/" element={<VisitorHome />} />
    </Routes>
  );
}

export default function App() {
  return (
    <Router>
      <AuthProvider>
        <Toaster position="top-center" richColors />
        <Suspense fallback={null}>
          <AppRouter />
        </Suspense>
      </AuthProvider>
    </Router>
  );
}
